export default __webpack_public_path__ + "static/media/correctIcon.4f4e0c0b.svg";